<!-- 活动预约列表 -->
<template>
  <div class="main-window-l">
    <div class="step-nav">
      <div class="nav-item active">
        产业嘉宾活动预约情况表
      </div>
    </div>
    
    <div class="center-pc tb">
      <table class="simple-tb">
        <tr class="th">
          <td style="width: 30%;">活动名称</td>
          <td style="width: 20%;">活动地点</td>
          <td style="width: 20%;">活动时间</td>
          <td style="width: 20%;">报名时间</td>
          <td style="width: 10%;">操作</td>
        </tr>
        <tr v-if="appointList.length == 0">
          <td colspan="5">暂无数据</td>
        </tr>
        <tr
          v-for="(item, index) in appointList"
          :key="index"
        >
          <td>
            <span class="tag-span">{{ item.activityTypeName }}</span>
            {{ item.activityName }}
          </td>
          <td>{{ item.activityAdress }}</td>
          <td>
            {{ item.activityStartTime | timeFilter('{y}/{m}/{d} {h}:{i}') }} - {{ item.activityEndTime | timeFilter('{y}/{m}/{d} {h}:{i}') }}
          </td>
          <td>
            {{ item.signStartTime | timeFilter('{y}/{m}/{d} {h}:{i}') }} - {{ item.signEndTime | timeFilter('{y}/{m}/{d} {h}:{i}') }}
          </td>
          <td>
            <span class="td-btn" @click="cancelBtn(item)">取消预约</span>
          </td>
        </tr>
      </table>
    </div>

    <div class="foo border-no">
      <button class="leftBtn" @click="goBack">返回</button>
      <button class="rightBtn" @click="toPage">去预约</button>
    </div>
  </div>
</template>

<script>
import { sessionData } from "@/static/js/local.js";
import { activityApi } from '@/api/industry';
let that;

export default {
  data() {
    return {
      userInfo: {},
      appointList: []
    }
  },
  filters: {
    timeFilter: function(tsp, type) {
      try {
        if (!tsp || tsp.toString().length == 0) {
          return ''
        }

        return that.$parseTime(tsp, type)
      } catch (err) {
        return ''
      }
    },
  },
  beforeCreate() {
    that = this;
  },
  created() {
    this.userInfo = sessionData("get", "UserInfo");
    if (this.userInfo && this.userInfo.accountId) {
      this.getList();
    } else {
      this.$message.warning('请先登录');
      this.goBack();
    }
  },
  methods: {
    getList() {
      const loading = this.$Loading.service({
        target: '#table',
        text: "",
        customClass: "custom-loading",
      });
      activityApi.getSignList({
        mainId: this.$session.get("cmm").mainId,
        accountId: this.userInfo.accountId
      }).then(res => {
        this.appointList = res.data;
      }).finally(() => {
        setTimeout(() => {
          loading.close();
        }, 500);
      })
    },
    cancelBtn(obj) {
      this.$msgbox({
        title: "确认信息",
        message: `确认取消预约“${obj.activityName}”`,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "cancel-btn-color",
        confirmButtonClass: "btn-color",
        callback: (action, instance) => {
          if (action == "confirm") {
            activityApi.cancel(obj.activitySignId).then(res => {
              this.$message.success('操作成功');
              this.getList();
            })
          }
        }
      });
    },
    goBack() {
      this.$router.push("/userIndex");
    },
    toPage() {
      this.$router.push({ name: 'activityAppoint' });
    }
  }
}
</script>

<style src="../../../static/css/regist.css" scoped></style>
<style src="../../../static/css/infoCommon.css" scoped></style>
<style scoped>
.tag-span {
  display: inline-block;
}
</style>